/* eslint-disable no-nested-ternary */
/* eslint-disable func-names */
/* eslint-disable max-len */
import * as Yup from 'yup';
import { useSelector } from 'react-redux';
import { EXERCISE_TYPE } from '../../../../../shared/constants';
/**
 * file for updating create exercise form validation and initial values and values to be submited
 based on type.
 */

const useCalendar = () => {
  const currentUser = useSelector((state) => state.auth.data.currentUser);
  const allExercises = useSelector((state) => state.calendar.data.allExercises);
  const liftExercises = allExercises.filter((exercise) => exercise.type === EXERCISE_TYPE.Lifts);
  const SAQCExercises = allExercises.filter((exercise) => exercise.type === EXERCISE_TYPE.SAQC);
  const CircuitExercises = allExercises.filter((exercise) => exercise.type === EXERCISE_TYPE.Circuits);
  const NoteExercises = allExercises.filter((exercise) => exercise.type === EXERCISE_TYPE.Note);
  const WarmUpExercises = allExercises.filter((exercise) => exercise.type === EXERCISE_TYPE.WarmUp);
  const CooldownExercises = allExercises.filter((exercise) => exercise.type === EXERCISE_TYPE.Cooldown);
  const QuestionnaireExercises = allExercises.filter((exercise) => exercise.type === EXERCISE_TYPE.Questionnaire);
  const hasExerciseManagementAccess = currentUser?.userSettings?.exercises === 1;

  const handleGetInitialValues = (type, sideBarExerciseSearchTerm, modalData) => {
    if (type === EXERCISE_TYPE.SAQC) {
      return {
        name: modalData?.itemInfoForEditModal ? modalData?.itemInfoForEditModal?.name : sideBarExerciseSearchTerm,
        type, /** string indicator for exercise type */
        uploadOrUrl: 'url',
        mediaType: modalData?.itemInfoForEditModal?.media?.length ? modalData?.itemInfoForEditModal?.media[0]?.type : '',
        videoUrl: modalData?.itemInfoForEditModal?.media?.length ? modalData?.itemInfoForEditModal?.media[0]?.mediaUrl : '',
        mediaUrl: modalData?.itemInfoForEditModal?.media?.length ? modalData?.itemInfoForEditModal?.media[0]?.thumbnailUrl : '',
        mediaId: null,
        tracking: modalData?.itemInfoForEditModal ? modalData?.itemInfoForEditModal?.track : 0, /** PR Tracking, 0 - not enabled, 1 - 1 rep max, 2 - total rep count, 3 - 3 rep max, 4 - total volume load */
        linkTo: (modalData?.itemInfoForEditModal && !!modalData.itemInfoForEditModal?.linkedMaxExerciseId && modalData.itemInfoForEditModal?.linkedMaxExerciseId !== 0) ? modalData.itemInfoForEditModal?.linkedMaxExerciseId : null, /** Enum for exercise Id? */
        linkPercentage: modalData?.itemInfoForEditModal ? modalData?.itemInfoForEditModal?.linkedMaxPercentage : 100, /** Enum 0-100 */
        description: modalData?.itemInfoForEditModal ? modalData?.itemInfoForEditModal?.description : '',
        documentId: null,
        inputType: modalData?.itemInfoForEditModal ? modalData?.itemInfoForEditModal?.inputType : 'C',
        unit: modalData?.itemInfoForEditModal && !!modalData?.itemInfoForEditModal?.unit ? modalData?.itemInfoForEditModal?.unit : 'None(Completion Only)',
        prSortOrder: modalData?.itemInfoForEditModal ? modalData?.itemInfoForEditModal?.prSortOrder : 0,
        reusableItem: modalData?.itemInfoForEditModal ? modalData.itemInfoForEditModal.reusableItem : !hasExerciseManagementAccess ? 0 : 1,
        cardioComp: modalData?.itemInfoForEditModal ? !!modalData?.itemInfoForEditModal?.defaultOptions?.cardioComp : false,
        cardioCoach: modalData?.itemInfoForEditModal ? !!modalData?.itemInfoForEditModal?.defaultOptions?.cardioCoach : false,
      };
    }
    if (type === EXERCISE_TYPE.Circuits) {
      return {
        name: modalData?.itemInfoForEditModal ? modalData?.itemInfoForEditModal?.name : sideBarExerciseSearchTerm,
        type, /** string indicator for exercise type */
        uploadOrUrl: 'url',
        mediaType: modalData?.itemInfoForEditModal?.media?.length ? modalData?.itemInfoForEditModal?.media[0]?.type : '',
        videoUrl: modalData?.itemInfoForEditModal?.media?.length ? modalData?.itemInfoForEditModal?.media[0]?.mediaUrl : '',
        mediaUrl: modalData?.itemInfoForEditModal?.media?.length ? modalData?.itemInfoForEditModal?.media[0]?.thumbnailUrl : '',
        mediaId: null,
        tracking: '',
        description: modalData?.itemInfoForEditModal ? modalData?.itemInfoForEditModal?.description : '',
        documentId: modalData?.itemInfoForEditModal ? modalData?.itemInfoForEditModal?.documentId : null,
        documentUrl: modalData?.itemInfoForEditModal ? modalData?.itemInfoForEditModal?.documentUrl : null,
        inputType: modalData?.itemInfoForEditModal ? modalData?.itemInfoForEditModal?.inputType : 'S',
        prSortOrder: modalData?.itemInfoForEditModal ? modalData?.itemInfoForEditModal?.prSortOrder : 0,
        reusableItem: modalData?.itemInfoForEditModal ? modalData.itemInfoForEditModal.reusableItem : !hasExerciseManagementAccess ? 0 : 1,
        detail: modalData?.itemInfoForEditModal ? modalData?.itemInfoForEditModal?.detail : '',
        detailType: modalData?.itemInfoForEditModal ? modalData?.itemInfoForEditModal?.detailType : null,
        coachCompletion: modalData?.itemInfoForEditModal ? modalData?.itemInfoForEditModal?.defaultOptions?.circuitCoach : null,
      };
    }
    if (type === EXERCISE_TYPE.Note || type === EXERCISE_TYPE.WarmUp || type === EXERCISE_TYPE.Cooldown) {
      return {
        name: modalData?.itemInfoForEditModal?.name ?? sideBarExerciseSearchTerm ?? '',
        type, /** string indicator for exercise type */
        uploadOrUrl: 'url',
        mediaType: modalData?.itemInfoForEditModal?.media?.length ? modalData?.itemInfoForEditModal?.media[0]?.type : '',
        videoUrl: modalData?.itemInfoForEditModal?.media?.length ? modalData?.itemInfoForEditModal?.media[0]?.mediaUrl : '',
        mediaUrl: modalData?.itemInfoForEditModal?.media?.length ? modalData?.itemInfoForEditModal?.media[0]?.thumbnailUrl : '',
        mediaId: null,
        description: modalData?.itemInfoForEditModal ? modalData?.itemInfoForEditModal?.description : '',
        documentId: null,
        /** AI import mirrors the BE and defaults save-to-database on; the build module keeps its original unchecked default. */
        reusableItem: modalData?.itemInfoForEditModal ? modalData?.itemInfoForEditModal?.reusableItem : (modalData?.openedFromAiImport && hasExerciseManagementAccess ? 1 : 0),
      };
    }
    if (type === EXERCISE_TYPE.Questionnaire) {
      return {
        name: modalData?.itemInfoForEditModal ? modalData?.itemInfoForEditModal?.name : sideBarExerciseSearchTerm,
        type, /** string indicator for exercise type */
        questionIds: modalData?.itemInfoForEditModal && !!modalData?.itemInfoForEditModal?.questions?.length ? modalData?.itemInfoForEditModal?.questions.map((q) => q.id) : [], /** An array of questionId values to associate with a questionnaire exercise type. This property is only valid for the S exercise type */
        questions: modalData?.itemInfoForEditModal && !!modalData?.itemInfoForEditModal?.questions?.length ? modalData?.itemInfoForEditModal?.questions : [], /** An array of questions associated with a questionnaire exercise type. This property is only valid for the S exercise type */
        description: modalData?.itemInfoForEditModal ? modalData?.itemInfoForEditModal?.description : '',
        documentId: null,
        reusableItem: modalData?.itemInfoForEditModal ? modalData.itemInfoForEditModal.reusableItem : !hasExerciseManagementAccess ? 0 : 1,
        track: modalData?.itemInfoForEditModal ? modalData?.itemInfoForEditModal?.track : 0, /** PR Tracking, 0 - not enabled, 1 - 1 rep max, 2 - total rep count, 3 - 3 rep max, 4 - total volume load */
      };
    }
    /** default type is Lift */
    if (type === EXERCISE_TYPE.Lifts) {
      return {
        name: modalData?.itemInfoForEditModal ? modalData?.itemInfoForEditModal?.name : sideBarExerciseSearchTerm,
        type, /** string indicator for exercise type */
        uploadOrUrl: 'url',
        mediaType: modalData?.itemInfoForEditModal?.media?.length ? modalData?.itemInfoForEditModal?.media[0]?.type : '',
        videoUrl: modalData?.itemInfoForEditModal?.media?.length ? modalData?.itemInfoForEditModal?.media[0]?.mediaUrl : '',
        mediaUrl: modalData?.itemInfoForEditModal?.media?.length ? modalData?.itemInfoForEditModal?.media[0]?.thumbnailUrl : '',
        mediaId: null,
        tracking: modalData?.itemInfoForEditModal ? modalData?.itemInfoForEditModal?.track : 0, /** PR Tracking, 0 - not enabled, 1 - 1 rep max, 2 - total rep count, 3 - 3 rep max, 4 - total volume load */
        linkTo: (modalData?.itemInfoForEditModal && !!modalData.itemInfoForEditModal?.linkedMaxExerciseId && modalData.itemInfoForEditModal?.linkedMaxExerciseId !== 0) ? modalData.itemInfoForEditModal?.linkedMaxExerciseId : null, /** Enum for exercise Id? */
        linkPercentage: modalData?.itemInfoForEditModal ? modalData?.itemInfoForEditModal?.linkedMaxPercentage : 100, /** Enum 0-100 */
        updateLinkedExerciseMax: modalData?.itemInfoForEditModal ? modalData?.itemInfoForEditModal?.linkedMaxExerciseUpdate : false,
        description: modalData?.itemInfoForEditModal ? modalData?.itemInfoForEditModal?.description : '',
        tags: modalData?.itemInfoForEditModal ? modalData?.itemInfoForEditModal?.tags : [], /** array[string] */
        completionOnly: modalData?.itemInfoForEditModal ? !!modalData?.itemInfoForEditModal?.defaultOptions?.liftComp : false,
        coachCompletion: modalData?.itemInfoForEditModal ? !!modalData?.itemInfoForEditModal?.defaultOptions?.liftCoachComp : false,
        bodyweightLift: modalData?.itemInfoForEditModal ? !!modalData?.itemInfoForEditModal?.defaultOptions?.liftRepsOnly : false,
        trackVolumeLoad: modalData?.itemInfoForEditModal ? !!modalData?.itemInfoForEditModal?.defaultOptions?.trackVolLoad : true,
        trackRepCount: modalData?.itemInfoForEditModal ? !!modalData?.itemInfoForEditModal?.defaultOptions?.trackRepCount : true,
        barSpeed: modalData?.itemInfoForEditModal ? !!modalData?.itemInfoForEditModal?.defaultOptions?.barSpeed : false,
        eachSide: modalData?.itemInfoForEditModal ? !!modalData?.itemInfoForEditModal?.defaultOptions?.eachSide : false,
        peakPower: modalData?.itemInfoForEditModal ? !!modalData?.itemInfoForEditModal?.defaultOptions?.peakPower : false,
      };
    }
    return {};
  };

  const handleGetFormValidationSchema = (type, modalData) => {
    const editModalExistingName = modalData?.itemInfoForEditModal?.name?.trim().toLowerCase();
    if (type === EXERCISE_TYPE.SAQC || type === EXERCISE_TYPE.Circuits) {
      let exercisesToNameCheck;
      if (type === EXERCISE_TYPE.SAQC) {
        exercisesToNameCheck = SAQCExercises;
      }
      if (type === EXERCISE_TYPE.Circuits) {
        exercisesToNameCheck = CircuitExercises;
      }

      /** base validation schema for R and C */
      const validationSchema = {
        name: Yup.string()
          .required('Exercise name is required')
          .max(100, 'Exercise name cannot exceed 100 characters') /** 100 character limit */
          .test(
            'unique-name',
            'Name already exists in your database for this exercise type, choose a different name to create exercise.',
            (value) => {
              if (!value) return false;

              const normalizedValue = value.trim().toLowerCase();

              /** Allow skipping if name hasn't changed (editing case) */
              if (editModalExistingName && normalizedValue === editModalExistingName) {
                return true;
              }

              /** Otherwise check for uniqueness */
              return !exercisesToNameCheck.some(
                (option) => option.name.trim().toLowerCase() === normalizedValue,
              );
            },
          ),
        videoUrl: Yup.string()
          .when('uploadOrUrl', {
            is: 'url', /** Only validate if uploadOrUrl is 'url' */
            then: Yup.string().url('Must be a valid URL').nullable(true),
            otherwise: Yup.string().nullable(true),
          }),
        linkPercentage: Yup.number()
          .typeError('Value must be a number')
          .min(0.01, 'Percentage must be greater than 0')
          .nullable()
          .notRequired()
          .when('linkTo', {
            is: (value) => value != null && value !== 'none', // Checks if linkTo has a value
            then: (schema) => schema.required('Link percentage is required'),
          }),
      };

      if (type === EXERCISE_TYPE.Circuits) {
        validationSchema.detail = Yup.string().when('detailType', {
          is: (detailType) => detailType === 'sets' || detailType === 'reps',
          then: Yup.string()
            .nullable()
            .notRequired()
            .test('valid-number-or-empty', 'Please enter a valid number', (value) => {
              if (!value || value.trim() === '' || value === '0') return true; // treat '' and '0' as empty
              return /^[1-9]\d*$/.test(value); // must be positive integer > 0
            }),
          otherwise: Yup.string()
            .nullable()
            .notRequired()
            .test('valid-time-or-empty', 'Please enter a valid time in the format MM:SS', (value) => {
              if (!value || value.trim() === '' || value === '0') return true; // treat '' and '0' as empty
              return /^(?:[0-9]{1,2}):([0-5][0-9])$/.test(value); // time format
            }),
        });
      }

      /** Return the constructed Yup validation schema */
      return Yup.object().shape(validationSchema);
    }

    if (type === EXERCISE_TYPE.Note) {
      return Yup.object().shape({
        /** Include reusableItem so we can reference it in .when() */
        reusableItem: Yup.boolean(),

        name: Yup.string().when('reusableItem', {
          is: true || 1, /** Only validate name if reusableItem is true or 1 */
          then: Yup.string()
            .required('Exercise name is required')
            .max(100, 'Exercise name cannot exceed 100 characters')
            .test(
              'unique-name',
              'Name already exists in your database for this exercise type, choose a different name to create exercise.',
              (value) => {
                if (!value) return false;

                const normalizedValue = value.trim().toLowerCase();

                /** Allow skipping if name hasn't changed (editing case) */
                if (editModalExistingName && normalizedValue === editModalExistingName) {
                  return true;
                }

                /** Otherwise check for uniqueness */
                return !NoteExercises.some(
                  (option) => option.name.trim().toLowerCase() === normalizedValue,
                );
              },
            ),
          otherwise: Yup.string().notRequired(),
        }),

        videoUrl: Yup.string().when('uploadOrUrl', {
          is: 'url', /** Only validate if uploadOrUrl is 'url' */
          then: Yup.string().url('Must be a valid URL').nullable(true),
          otherwise: Yup.string().nullable(true),
        }),

        description: Yup.string().required('Description is required'),
      });
    }

    if (type === EXERCISE_TYPE.WarmUp) {
      return Yup.object().shape({
        name: Yup.string().when('reusableItem', {
          is: true || 1, /** Only validate name if reusableItem is true or 1 */
          then: Yup.string()
            .required('Exercise name is required')
            .max(100, 'Exercise name cannot exceed 100 characters') /** 100 character limit */
            .test(
              'unique-name',
              'Name already exists in your database for this exercise type, choose a different name to create exercise.',
              (value) => {
                if (!value) return false;

                const normalizedValue = value.trim().toLowerCase();

                /** Allow skipping if name hasn't changed (editing case) */
                if (editModalExistingName && normalizedValue === editModalExistingName) {
                  return true;
                }

                /** Otherwise check for uniqueness */
                return !WarmUpExercises.some(
                  (option) => option.name.trim().toLowerCase() === normalizedValue,
                );
              },
            ),
          otherwise: Yup.string().notRequired(),
        }),
        videoUrl: Yup.string()
          .when('uploadOrUrl', {
            is: 'url', /** Only validate if urlButtonValue is 'url' */
            then: Yup.string().url('Must be a valid URL').nullable(true),
            otherwise: Yup.string().nullable(true),
          }),
        description: Yup.string()
          .required('description is required'),
      });
    }

    if (type === EXERCISE_TYPE.Cooldown) {
      return Yup.object().shape({
        name: Yup.string().when('reusableItem', {
          is: true || 1, /** Only validate name if reusableItem is true or 1 */
          then: Yup.string()
            .required('Exercise name is required')
            .max(100, 'Exercise name cannot exceed 100 characters') /** 100 character limit */
            .test(
              'unique-name',
              'Name already exists in your database for this exercise type, choose a different name to create exercise.',
              (value) => {
                if (!value) return false;

                const normalizedValue = value.trim().toLowerCase();

                /** Allow skipping if name hasn't changed (editing case) */
                if (editModalExistingName && normalizedValue === editModalExistingName) {
                  return true;
                }

                /** Otherwise check for uniqueness */
                return !CooldownExercises.some(
                  (option) => option.name.trim().toLowerCase() === normalizedValue,
                );
              },
            ),
          otherwise: Yup.string().notRequired(),
        }),
        videoUrl: Yup.string()
          .when('uploadOrUrl', {
            is: 'url', /** Only validate if urlButtonValue is 'url' */
            then: Yup.string().url('Must be a valid URL').nullable(true),
            otherwise: Yup.string().nullable(true),
          }),
        description: Yup.string()
          .required('description is required'),
      });
    }

    if (type === EXERCISE_TYPE.Questionnaire) {
      return Yup.object().shape({
        name: Yup.string()
          .required('Exercise name is required')
          .max(100, 'Exercise name cannot exceed 100 characters') /** 100 character limit */
          .test(
            'unique-name',
            'Name already exists in your database for this exercise type, choose a different name to create exercise.',
            (value) => {
              if (!value) return false;

              const normalizedValue = value.trim().toLowerCase();

              /** Allow skipping if name hasn't changed (editing case) */
              if (editModalExistingName && normalizedValue === editModalExistingName) {
                return true;
              }

              /** Otherwise check for uniqueness */
              return !QuestionnaireExercises.some(
                (option) => option.name.trim().toLowerCase() === normalizedValue,
              );
            },
          ),
        questionIds: Yup.array()
          .of(Yup.number().required('Each question ID must be a valid number'))
          .min(1, 'Please select at least one question') /** Ensure at least one question is selected */
          .required('Please select at least one question'),
      });
    }

    /** default return in validation for type Lift */
    return Yup.object().shape({
      name: Yup.string()
        .required('Exercise name is required')
        .max(100, 'Exercise name cannot exceed 100 characters') /** 100 character limit */
        .test(
          'unique-name',
          'Name already exists in your database for this exercise type, choose a different name to create exercise.',
          (value) => {
            if (!value) return false;

            const normalizedValue = value.trim().toLowerCase();

            /** Allow skipping if name hasn't changed (editing case) */
            if (editModalExistingName && normalizedValue === editModalExistingName) {
              return true;
            }

            /** Otherwise check for uniqueness */
            return !liftExercises.some(
              (option) => option.name.trim().toLowerCase() === normalizedValue,
            );
          },
        ),
      videoUrl: Yup.string()
        .when('uploadOrUrl', {
          is: 'url', /** Only validate if urlButtonValue is 'url' */
          then: Yup.string().url('Must be a valid URL').nullable(true),
          otherwise: Yup.string().nullable(true),
        }),
      linkPercentage: Yup.number()
        .typeError('Value must be a number')
        .min(0.01, 'Percentage must be greater than 0')
        .nullable()
        .notRequired()
        .when('linkTo', {
          is: (value) => value != null && value !== 'none', /** Checks if linkTo has a value */
          then: (schema) => schema.required('Link percentage is required'),
        }),
    });
  };

  const handleGetUpdatedValuesToSubmit = (currentFormValues) => {
    let baseValues;

    baseValues = currentFormValues;

    if (currentFormValues?.type === EXERCISE_TYPE.SAQC) {
      baseValues = {
        name: currentFormValues?.name, /** required field */
        type: currentFormValues?.type, /** required field */
        linkedMaxExerciseId: currentFormValues?.linkTo === 'none' ? null : currentFormValues?.linkTo,
        linkedMaxPercentage: currentFormValues?.linkTo && currentFormValues?.linkPercentage ? parseInt(currentFormValues.linkPercentage, 10) : null,
        mediaIds: currentFormValues?.mediaId
          ? [currentFormValues.mediaId] /** Wrap the mediaId in an array if it exists */
          : null,
        description: currentFormValues?.description,
        documentId: currentFormValues?.documentId,
        inputType: currentFormValues?.inputType,
        unit: currentFormValues?.unit === 'None(Completion Only)' ? null : currentFormValues?.unit,
        prSortOrder: currentFormValues?.prSortOrder,
        track: currentFormValues?.prSortOrder > 0 ? 1 : 0,
        reusableItem: currentFormValues?.reusableItem ? 1 : 0,
        /** additional options */
        defaultOptions: {
          cardioCoach: currentFormValues?.cardioCoach ? 1 : null, /** Flag indicating the exercise can only be completed by a coach */
          cardioComp: currentFormValues?.cardioComp || currentFormValues.inputType === 'C' ? 1 : null, /** Flag indicating the exercise is completion only */
        },
      };
    }
    if (currentFormValues?.type === EXERCISE_TYPE.Circuits) {
      baseValues = {
        name: currentFormValues?.name, /** required field */
        type: currentFormValues?.type, /** required field */
        mediaIds: currentFormValues?.mediaId
          ? [currentFormValues.mediaId] /** Wrap the mediaId in an array if it exists */
          : null,
        description: currentFormValues?.description,
        documentId: currentFormValues?.documentId,
        prSortOrder: currentFormValues?.prSortOrder,
        track: currentFormValues?.prSortOrder > 0 ? 1 : 0,
        reusableItem: currentFormValues?.reusableItem ? 1 : 0,
        inputType: currentFormValues?.inputType,
        detail: currentFormValues?.detail ? String(currentFormValues.detail) : '',
        detailType: currentFormValues?.inputType === EXERCISE_TYPE.Circuits || currentFormValues?.inputType === EXERCISE_TYPE.Tag ? currentFormValues?.detailType : null,
        defaultOptions: {
          circuitCoach: currentFormValues?.coachCompletion ? 1 : null,
        },
      };
    }
    if (currentFormValues?.type === EXERCISE_TYPE.Note || currentFormValues?.type === EXERCISE_TYPE.WarmUp || currentFormValues?.type === EXERCISE_TYPE.Cooldown) {
      let name = currentFormValues?.name;

      if (!name || name.trim() === '') {
        if (currentFormValues?.type === EXERCISE_TYPE.Note) name = 'Note';
        else if (currentFormValues?.type === EXERCISE_TYPE.WarmUp) name = 'Warm-Up';
        else if (currentFormValues?.type === EXERCISE_TYPE.Cooldown) name = 'Cooldown';
      }
      baseValues = {
        name,
        type: currentFormValues?.type, /** required field */
        mediaIds: currentFormValues?.mediaId
          ? [currentFormValues.mediaId] /** Wrap the mediaId in an array if it exists */
          : null,
        description: currentFormValues?.description,
        documentId: currentFormValues?.documentId,
        reusableItem: currentFormValues?.reusableItem ? 1 : 0,
      };
    }
    if (currentFormValues?.type === EXERCISE_TYPE.Questionnaire) {
      baseValues = {
        name: currentFormValues?.name, /** required field */
        type: currentFormValues?.type, /** required field */
        questionIds: currentFormValues?.questionIds,
        description: currentFormValues?.description,
        documentId: currentFormValues?.documentId,
        reusableItem: currentFormValues?.reusableItem ? 1 : 0,
        track: currentFormValues?.track ? 1 : 0,
      };
    }
    if (currentFormValues?.type === EXERCISE_TYPE.Lifts) {
      baseValues = {
        name: currentFormValues?.name, /** required field */
        type: currentFormValues?.type, /** required field */
        linkedMaxExerciseId: currentFormValues?.linkTo === 'none' ? null : currentFormValues?.linkTo,
        linkedMaxExerciseUpdate: currentFormValues?.updateLinkedExerciseMax, /** ??? */
        linkedMaxPercentage: currentFormValues.linkTo && currentFormValues?.linkPercentage ? parseInt(currentFormValues.linkPercentage, 10) : null,
        mediaIds: currentFormValues?.mediaId
          ? [currentFormValues.mediaId] /** Wrap the mediaId in an array if it exists */
          : null,
        tags: currentFormValues?.tags,
        track: currentFormValues?.tracking, /** PR Tracking, 0 - not enabled, 1 - 1 rep max, 2 - total rep count, 3 - 3 rep max, 4 - total volume load */
        description: currentFormValues?.description,
        /** additional options */
        defaultOptions: {
          liftComp: currentFormValues?.completionOnly ? 1 : null,
          liftCoachComp: currentFormValues?.coachCompletion ? 1 : null,
          trackVolLoad: currentFormValues?.trackVolumeLoad ? 1 : null,
          trackRepCount: currentFormValues?.trackRepCount ? 1 : null,
          barSpeed: currentFormValues?.barSpeed ? 1 : null,
          eachSide: currentFormValues?.eachSide ? 1 : null,
          peakPower: currentFormValues?.peakPower ? 1 : null,
          liftRepsOnly: currentFormValues?.bodyweightLift ? 1 : null,
        },
      };
    }
    /** Build and return the final object, excluding any properties with empty values */
    const updatedValues = Object.entries(baseValues).reduce((acc, [key, value]) => {
      if (
        value !== ''
        && value !== null
        && !(Array.isArray(value) && value.length === 0)
        && !(value && typeof value === 'object' && Object.keys(value).length === 0)
      ) {
        acc[key] = value;
      }
      return acc;
    }, {});

    return updatedValues;
  };

  const handleGetCreatNewQuestionFormValidationSchema = () => {
    const NewQuestionSchema = Yup.object().shape({
      inputType: Yup.number().required('InputType is required'),
      name: Yup.string().required('Name is required'),
      abbreviation: Yup.string()
        .required('Abbreviation is required')
        .max(10, '10 character max'),
      description: Yup.string().required('Description is required'),
      minimum: Yup.number()
        .when('inputType', {
          is: 0, /** Apply validation only if inputType is 0 aka range slider */
          then: Yup.number()
            .required('Min is required')
            .min(0, 'Min must be >= 0')
            /** make sure user can't send -0 */
            .test('min-no-negative-zero', 'Invalid input', (maximum) => !Object.is(maximum, -0))
            .typeError('Must be #')
            .test('min-less-than-max', 'Min must be < Max', function (minimum) {
              const { maximum } = this.parent;
              return maximum === undefined || minimum < maximum; /** Ensure `min` is less than `max` */
            }),
        }),
      maximum: Yup.number()
        .when('inputType', {
          is: 0, /** Apply validation only if inputType is 0 aka range slider */
          then: Yup.number()
            .required('Max is required')
            .min(0, 'Negatives not allowed')
            /** make sure user can't send -0 */
            .test('max-no-negative-zero', 'Invalid input', (maximum) => !Object.is(maximum, -0))
            .typeError('Must be #')
            .test('max-greater-than-min', 'Max must be > min', function (maximum) {
              const { minimum } = this.parent;
              return minimum === undefined || maximum > minimum;
            }),
        })
        .test('min-not-equal-to-max', 'Min cannot = max', function (maximum) {
          const { minimum } = this.parent;
          return minimum === undefined || maximum === undefined || minimum !== maximum;
        }),
      lowerThreshold: Yup.number()
        .nullable()
        .when('inputType', {
          is: 0, /** Apply validation only if inputType is 0 aka range slider */
          then: Yup.number()
            .min(0, 'Negatives not allowed')
            /** make sure user can't send -0 */
            .test('min-no-negative-zero', 'Invalid input', (lowerThreshold) => !Object.is(lowerThreshold, -0))
            .typeError('Input must be a #')
            .test('lower-required-if-upper', 'Lower is required when Upper is set', function (lowerThreshold) {
              const { upperThreshold } = this.parent;
              return upperThreshold == null || lowerThreshold != null; /** If Upper is set, Lower must be set */
            })
            .test('lower-less-than-upper', 'Lower must be < upper', function (lowerThreshold) {
              const { upperThreshold } = this.parent;
              if (lowerThreshold == null || upperThreshold == null) return true;
              return lowerThreshold < upperThreshold;
            }),
        }),
      upperThreshold: Yup.number()
        .nullable()
        .when('inputType', {
          is: 0, /** Apply validation only if inputType is 0 aka range slider */
          then: Yup.number()
            .min(0, 'Negatives not allowed')
            /** make sure user can't send -0 */
            .test('upper-no-negative-zero', 'Invalid input', (upperThreshold) => !Object.is(upperThreshold, -0))
            .typeError('Input must be a #')
            .test('upper-required-if-lower', 'Upper is required when Lower is set', function (upperThreshold) {
              const { lowerThreshold } = this.parent;
              return lowerThreshold == null || upperThreshold != null; /** If Lower is set, Upper must be set */
            })
            .test('cannot-exceed-max-in-range-slider', 'Upper must be <= to max in range slider', function (upperThreshold) {
              const { maximum } = this.parent;
              if (upperThreshold == null || maximum == null) return true; /** Skip validation if upperThreshold or maximum is null */
              return upperThreshold <= maximum;
            })
            .test('upper-greater-than-lower', 'Upper must be > lower', function (upperThreshold) {
              const { lowerThreshold } = this.parent;
              if (upperThreshold == null || lowerThreshold == null) return true; // Skip validation if either value is null
              return upperThreshold > lowerThreshold;
            }),
        }),

      choicesArray: Yup.array()
        .when('inputType', {
          is: 3,
          then: Yup.array()
            .min(1, 'At least one option is required'),
        }),
    });

    return NewQuestionSchema;
  };

  const handleGetCustomSelectStylesForNewQuestionDropdown = () => {
    const customSelectStyles = {
      control: (provided, state) => ({
        ...provided,
        borderTopRightRadius: state.options.some((option) => option.id === 'sets') && '0px',
        borderBottomRightRadius: state.options.some((option) => option.id === 'sets') && '0px',
        fontFamily: 'Nunito Sans',
        fontSize: '16px',
        fontWeight: 400,
        background: state.options.some((option) => option.id === 'sets') ? '#FCFCFC' : 'white',
        borderColor: state.isFocused ? 'lightgray' : 'lightgray',
        boxShadow: state.isFocused ? 'none' : 'none',
        '&:hover': {
          borderColor: state.isFocused ? 'lightgray' : 'lightgray',
        },
      }),
      option: (provided, state) => ({
        ...provided,
        padding: '4px',
        backgroundColor: 'white',
        color: state.isSelected ? '#BDBDBD' : '#444444',
        fontFamily: 'Nunito Sans',
        fontSize: '16px',
        marginBottom: '8px',
        fontWeight: 400,
        '&:hover': {
          backgroundColor: '#FCFCFC',
        },
        paddingLeft: state.data.isGrouped && '12px',
      }),
      multiValue: (styles) => ({
        ...styles,
        backgroundColor: '#FCFCFC',
        border: '1px solid #EEEEEE',
        borderRadius: '4px',
      }),
      multiValueLabel: (styles) => ({
        ...styles,
        color: '#444444',
      }),
      multiValueRemove: (styles) => ({
        ...styles,
        color: '#9E9E9E',
      }),
      menu: (provided) => ({
        ...provided,
        border: '0px',
        minWidth: '250px',
        padding: '16px',
        marginTop: '0px',
        marginBottom: '0px',
      }),
      menuList: (provided) => ({
        ...provided,
        maxHeight: '500px',
      }),
      group: (provided) => ({
        ...provided,
        padding: '0px',
      }),
      groupHeading: (provided) => ({
        ...provided,
        fontSize: '16px',
        fontWeight: 700,
        color: '#9E9E9E',
        paddingLeft: '0px',
        paddingRight: '0px',
        marginBottom: '8px',
        fontFamily: 'Nunito Sans',
        textTransform: 'none',
      }),
      placeholder: (provided) => ({
        ...provided,
        color: '#9E9E9E',
      }),
      input: (provided, state) => ({
        ...provided,
        color: state.isDisabled ? 'inherit' : provided.color, /** Use 'inherit' to maintain original color */
      }),
    };

    return customSelectStyles;
  };

  return {
    handleGetInitialValues,
    handleGetFormValidationSchema,
    handleGetUpdatedValuesToSubmit,
    handleGetCreatNewQuestionFormValidationSchema,
    handleGetCustomSelectStylesForNewQuestionDropdown,
  };
};

export default useCalendar;
